import type { EmploymentRecordItem } from "@/shared/api/documentSuggest";

export interface EtkExperienceRow {
  organization_name: string;
  work_position: string;
  begin_month: number | null;
  begin_year: number | null;
  end_month: number | null;
  end_year: number | null;
  is_current: boolean;
}

export function parseEtkMonthYear(dateStr: string | null | undefined): { month: number | null; year: number | null } {
  if (!dateStr) return { month: null, year: null };
  const parsed = new Date(dateStr);
  if (isNaN(parsed.getTime())) return { month: null, year: null };
  return { month: parsed.getMonth() + 1, year: parsed.getFullYear() };
}

export function mapEtkItemToRow(item: EmploymentRecordItem): EtkExperienceRow {
  const begin = parseEtkMonthYear(item.start_date);
  const end = parseEtkMonthYear(item.end_date);
  return {
    organization_name: item.employer_name ?? "",
    work_position: item.position ?? "",
    begin_month: begin.month,
    begin_year: begin.year,
    end_month: item.is_current ? null : end.month,
    end_year: item.is_current ? null : end.year,
    is_current: item.is_current,
  };
}

export function experienceDedupKey(
  organizationName: string,
  beginYear: number | null,
  beginMonth: number | null,
): string {
  return `${organizationName.trim().toLowerCase()}|${beginYear ?? ""}-${beginMonth ?? ""}`;
}
